export default __webpack_public_path__ + "static/zaki-508c1ef1584a38584c63846367efecc6.png";